import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'DEVICE_RECHARGE_CONFIG_ALL',
        delete: 'DEVICE_RECHARGE_CONFIG_DELETE'
      },
      permission: {
        query: '',
        add: 'device:recharge:config:add',
        edit: 'device:recharge:config:edit',
        detail: '',
        remove: 'device:recharge:config:remove'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      return [{
        prop: 'id',
        label: 'id',
        minWidth: '80px'
      }, {
        prop: 'market_id',
        label: 'market_id',
        minWidth: '80px'
      }, {
        prop: 'app_id',
        label: 'app_id',
        minWidth: '80px'
      }, {
        prop: 'key',
        label: 'key',
        minWidth: '160px'
      }, {
        prop: 'url',
        label: 'url',
        minWidth: '160px'
      }, {
        prop: 'c_time',
        label: 'c_time',
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.c_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'u_time',
        label: 'u_time',
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.u_time, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref) {
        var row = _ref.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'app_id',
        label: 'app_id',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:190px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.app_id,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "app_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: 'start_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: 'end_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread({}, mapActions('d2admin/page', ['closeBy']))
};